import { render } from "./ActiveUploadsWidget.vue?vue&type=template&id=7131b579&scoped=true"
import script from "./ActiveUploadsWidget.vue?vue&type=script&lang=js"
export * from "./ActiveUploadsWidget.vue?vue&type=script&lang=js"

import "./ActiveUploadsWidget.vue?vue&type=style&index=0&id=7131b579&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7131b579"]])

export default __exports__